<template>
  <div :class="$options.name">
    <v-menu close-on-click close-on-content-click>
      <template v-slot:activator="{ on }">
        <v-btn
          color="success"
          class="elevation-0"
          title="Экспорт данных"
          dark
          v-on="on"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-subheader>Экспорт данных</v-subheader>
        <v-list-item @click="sendExport('shp')">
          <v-list-item-title>Shapefile</v-list-item-title>
        </v-list-item>

        <v-list-item @click="sendExport('csv')">
          <v-list-item-title>CSV</v-list-item-title>
        </v-list-item>

        <v-list-item @click="sendExport('geojson')">
          <v-list-item-title>GeoJson</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { prepareExport } from '@/utils/requests/export';

export default {
  name: 'data-import-dialog',
  components: {},
  props: {
    objectId: String,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    ...mapActions(['showNotify']),

    sendExport(type) {
      prepareExport(this.objectId, type);
      this.showNotify({
        message: 'Экспорт данных начался, дождитесь завершения.'
          + ' Скачать файл можно будет в окне уведомлений',
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
